module.exports = __webpack_public_path__ + "img/CtrlRoom_setting.96f37101.png";